import {
  GET_ALL_DEPARTMENTS,
  GET_DEPARTMENT,
  LOADING_DEPARTMENT,
  ERROR_DEPARTMENT,
  ADD_DEPARTMENT,
  UPDATE_DEPARTMENT,
  DELETE_DEPARTMENT
} from "store/actions/departmentAction";

export default (store = {}, action) => {
  switch (action.type) {
    case LOADING_DEPARTMENT:
      return {
        ...store,
        isLoadingDepartment: action.payload
      };
    case ERROR_DEPARTMENT:
      return {
        ...store,
        errorDepartment: action.payload
      };
    case GET_ALL_DEPARTMENTS:
      return {
        ...store,
        getAllDepartments: action.payload
      };
    case GET_DEPARTMENT:
      return {
        ...store,
        getDepartment: action.payload
      };
    case ADD_DEPARTMENT:
      return {
        ...store,
        addDepartment: action.payload
      };
    case UPDATE_DEPARTMENT:
      return {
        ...store,
        updateDepartment: action.payload
      };
    case DELETE_DEPARTMENT:
      return {
        ...store,
        deleteDepartmentStatus: action.payload
      };
    default:
      return store;
  }
};
